"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCreatorsTableFilters = exports.defaultDashboardFilters = void 0;
const moment_mini_1 = __importDefault(require("moment-mini"));
const platforms_1 = require("root/src/shared/@types/platforms");
const dashboard_1 = require("root/src/shared/@types/dashboard");
exports.defaultDashboardFilters = {
    from: (0, moment_mini_1.default)()
        .subtract(7, 'days')
        .format(),
    to: (0, moment_mini_1.default)().format(),
};
exports.defaultCreatorsTableFilters = {
    ambassadorsOnly: false,
    platforms: [platforms_1.Platform.Twitch],
    currentPage: 1,
    sortBy: 'minutesViewed',
    sort: dashboard_1.DashboardSortTypes.DESC,
};
